import { useState } from "react";
import "./Services.scss"; // Import do SCSS


import { Button } from "@mui/material";
import ServiceDialog from "./ServiceDialog";
import { servicesData } from "./servicesData";



const Service = () => {
  const [openDialogId, setOpenDialogId] = useState<string | null>(null);

  const handleOpenDialog = (sectionLink: string) => {
    setOpenDialogId(sectionLink);
  };

  const handleCloseDialog = () => {
    setOpenDialogId(null);
  };

  // serviço atualmente selecionado
  const currentService = servicesData.find(s => s.sectionLink === openDialogId);

  return (
    <section className="services-cards" id="services">
      <div className="cards-container" data-aos="fade-up">
        <h2>Serviços</h2>

        <p style={{textAlign: "center"}}>
          Nosso trabalho começa com o cuidado genuíno com as pessoas. Por isso,
          desenvolvemos um protocolo exclusivo de anamnese física e emocional,
          realizado antes dos atendimentos.
        </p>

        <div className="cards-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card" id={service.sectionLink} data-aos="fade-up">
              <div className="card-image">
                <img src={service.imageUrl} alt={service.title} />
              </div>
              <div className="card-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.benefits.map((benefit, i) => (
                    <li key={i}>{benefit}</li>
                  ))}
                </ul>
                <Button onClick={() => handleOpenDialog(service.sectionLink)} className="fixed-bottom-button">
                  Saiba Mais
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {currentService && (
        <ServiceDialog
          serviceId={currentService.sectionLink}
          open={true}
          onClose={handleCloseDialog}
        />
      )}
    </section>
  );
};


export default Service;
